import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'parentGroupContact',
    label: 'Parent Group Contact',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
